import { forwardRef } from "react";
import { Styled } from "./style";
import { notification, Radio, Tooltip } from "antd";
import { handleMessageError } from "@lhd/features/Apps/utils";
import { usePutSettingSize } from "@lhd/hooks";
import { DisplaySize, OPTIONS_SETTING_SIZES } from "@lhd/constants";

interface DisplaySizeSelectorProps {
  defaultValue?: DisplaySize;
  onChange?: (value: DisplaySize) => void;
  disabled?: boolean;
}

const DisplaySizeSelector = (
  props: DisplaySizeSelectorProps,
  _ref: unknown,
) => {
  const { defaultValue, disabled } = props;

  const { mutate } = usePutSettingSize();

  const onChangeSize = (value: string) => {
    mutate(value, {
      onError(e: any) {
        notification["error"]({
          message: handleMessageError(e?.response?.data?.error),
        });
      },
    });
  };

  return disabled ? (
    <Tooltip
      placement="bottom"
      title="このページはサイズ変更できません。"
      mouseEnterDelay={0.2}
      mouseLeaveDelay={0.1}
      destroyTooltipOnHide={true}
      trigger={["hover"]}
    >
      <Styled style={{ position: "relative" }}>
        <div className="display-size-container">
          <Radio.Group
            options={OPTIONS_SETTING_SIZES}
            value={""}
            optionType="button"
            className="display-size__radio-group"
            onChange={(e) => onChangeSize?.(e.target.value)}
            disabled={disabled}
          />
        </div>
      </Styled>
    </Tooltip>
  ) : (
    <Styled style={{ position: "relative" }}>
      <div className="display-size-container">
        <Radio.Group
          options={OPTIONS_SETTING_SIZES}
          value={defaultValue}
          optionType="button"
          className="display-size__radio-group"
          onChange={(e) => onChangeSize?.(e.target.value)}
        />
      </div>
    </Styled>
  );
};

export default forwardRef(DisplaySizeSelector);
